import axios from 'axios';
import { useEnvironment } from '../contexts/EnvorimentContext';
const ApiServices = () => {
    const { environment } = useEnvironment();
    const baseURLs = {
        develop: 'https://apigw.dev.smilesviagens.com.br/',
        homol: 'https://apigw.hml.smilesviagens.com.br/',
        preprod: 'https://apigw.smilesviagens.com.br/',
        production: 'https://apigw.smilesviagens.com.br/',
    };
    const baseURL = baseURLs[environment];
    return axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
export default ApiServices;
//# sourceMappingURL=axiosConfig.js.map